import { render } from "./razones-sociales.vue?vue&type=template&id=1c46b782&scoped=true"
import script from "./razones-sociales.vue?vue&type=script&lang=js"
export * from "./razones-sociales.vue?vue&type=script&lang=js"

import "./razones-sociales.vue?vue&type=style&index=0&id=1c46b782&scoped=true&lang=css"
import "./razones-sociales.vue?vue&type=style&index=1&id=1c46b782&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c46b782"]])

export default __exports__